import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Close } from "@mui/icons-material";

import toast from "react-hot-toast";
import { assignAnalyst, portMatch, removeAnalystAssignment } from "../../redux/actions/adminAction";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import dayjs from "dayjs";
import Select from "react-select";

import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { DateTime } from "luxon";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    backgroundColor: "var(--surface-2)",
    "& fieldset": { borderColor: "var(--border-1)" },
    "&:hover fieldset": { borderColor: "var(--text-2)" },
    "&.Mui-focused fieldset": { borderColor: "rgba(232,108,0,0.6)" },
  },
  "& .MuiInputLabel-root": {
    fontSize: "13px",
    color: "var(--text-2)",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "rgba(232,108,0,0.8)",
  },
};

const FieldLabel = ({ children, required }) => (
  <Typography
    sx={{
      fontSize: "12px",
      fontWeight: 600,
      color: "var(--text-2)",
      mb: 0.5,
    }}
  >
    {children}
    {required && <span style={{ color: "#EF4444", marginLeft: 2 }}>*</span>}
  </Typography>
);

const LabeledField = ({ label, required, children }) => (
  <Stack sx={{ flex: 1, minWidth: 0 }}>
    <FieldLabel required={required}>{label}</FieldLabel>
    {children}
  </Stack>
);

const analysisOptions = [
  { value: 1, label: "Old Type" },
  { value: 2, label: "New Type" },
  { value: 3, label: "Extra Events" },
  { value: 4, label: "Sydney FC" },
  { value: 5, label: "Updated Coordinate System" },
];

export default function EditDialog({ open, handleClose, data, refreshData }) {
  const formatDateAndTime = (dateWithTime) => {
    if (dateWithTime) {
      const utcTime = DateTime.fromISO(dateWithTime, { zone: "utc" });
      const istTime = utcToZonedTime(utcTime.toJSDate(), "Asia/Kolkata");
      return format(istTime, "PPpp");
    } else {
      return null;
    }
  };

  let already_assign_date_data = formatDateAndTime(data?.analysis_sense_data?.assigned_date);
  let already_due_date_data = formatDateAndTime(data?.analysis_sense_data?.due_date);

  const [analysts, setAnalysts] = React.useState([]);
  const [reviewers, setReviewers] = React.useState([]);
  const [organizer, setOrganizer] = React.useState([]);
  const [analysisType, setAnalysisType] = React.useState(null);
  const [selectedAssignDate, setSelectedAssignDate] = React.useState(null);
  const [selectedDueDate, setSelectedDueDate] = React.useState(null);
console.log(analysisType, "analysisType");
  const today = new Date();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { allAnalyst, allOrganizer, updatingAnalysts, portingAccounts, updatingAllDate } = useSelector((state) => state.admin);

  const isDarkMode = document.body.classList.contains("theme-dark");

  React.useEffect(() => {
    if (data?.analyst_details) {
      setAnalysts(data?.analyst_details?.map((i) => i.id) || []);
      setReviewers(data?.reviewer_details?.map((i) => i.id) || []);
      setOrganizer(data?.organizer_details?.map((i) => i.id) || []);
    }
  }, [data]);

  // Re-sync on every open; data is null on close, which clears it so the next match doesn't inherit it.
  React.useEffect(() => {
    setAnalysisType(analysisOptions.find((o) => o.value === data?.analysis_setup) ?? null);
  }, [data]);

  React.useEffect(() => {
    handleAssignDateChange();
    handleDueDateChange();
  }, [data]);

  const handleAnalystChange = (value) => setAnalysts([...value]);
  const handleReviewerChange = (value) => setReviewers([...value]);
  const handleOrganizerChange = (event) => setOrganizer(event.target.value);
  const handleAssignDateChange = (date) => setSelectedAssignDate(date);
  const handleDueDateChange = (date) => setSelectedDueDate(date);

  // Usernames for ids, checking the match's own lists first so people missing
  // from the analyst list (e.g. inactive) still resolve.  null if any can't.
  const usernamesFor = (ids) => {
    const known = [...(data?.analyst_details ?? []), ...(data?.reviewer_details ?? []), ...(allAnalyst ?? [])];
    const names = ids.map((id) => known.find((u) => u.id === id && u.username)?.username);
    return names.every(Boolean) ? names : null;
  };

  const handleUpdate = async () => {
    const originalAnalysts = data?.analyst_details?.map((i) => i.id) ?? [];
    const originalReviewers = data?.reviewer_details?.map((i) => i.id) ?? [];
    const removedAnalysts = usernamesFor(originalAnalysts.filter((id) => !analysts.includes(id)));
    const removedReviewers = usernamesFor(originalReviewers.filter((id) => !reviewers.includes(id)));
    const analyst_data = usernamesFor(analysts);
    const reviewer_data = usernamesFor(reviewers);

    if (!removedAnalysts || !removedReviewers || !analyst_data || !reviewer_data) {
      toast.error("Some analysts or reviewers could not be identified. Reload the page and try again.");
      return;
    }

    // port_entity only adds organizers (and re-links every player per call),
    // so it is sent the new organizers only; removal has no backend endpoint.
    const originalOrganizers = data?.organizer_details?.map((i) => i.id) ?? [];
    const addedOrganizers = organizer.filter(
      (id) => !originalOrganizers.includes(id) && allOrganizer.some((u) => u.id === id)
    );
    const removedOrganizers = originalOrganizers.filter((id) => !organizer.includes(id));

    let Assign_date_data = data?.analysis_sense_data?.assigned_date;
    let Due_date_data = data?.analysis_sense_data?.due_date;

    // assign v2 also resets the match status to "resources assigned", so it is
    // only called when someone is added or the dates / analysis type change.
    const peopleAdded =
      analysts.some((id) => !originalAnalysts.includes(id)) ||
      reviewers.some((id) => !originalReviewers.includes(id));
    const setupChanged =
      Boolean(selectedAssignDate) ||
      Boolean(selectedDueDate) ||
      // Compared via the options so an unlisted stored value counts as unchanged.
      (analysisType?.value ?? null) !==
        (analysisOptions.find((o) => o.value === data?.analysis_setup)?.value ?? null);
    const needsAssign = peopleAdded || setupChanged;

    if (removedOrganizers.length > 0) {
      const names = removedOrganizers
        .map((id) => data.organizer_details.find((o) => o.id === id)?.name ?? id)
        .join(", ");
      toast.error(`Removing organizers isn't supported yet — ${names} will stay linked to this match.`);
    }

    if (!needsAssign && removedAnalysts.length === 0 && removedReviewers.length === 0 && addedOrganizers.length === 0) {
      handleClose();
      return;
    }

    // assign v2 only adds, so sending everyone still selected is safe and also
    // saves the dates and analysis type.
    const assigned =
      !needsAssign ||
      (await dispatch(
        assignAnalyst({
          data: {
            analyst_username: analyst_data,
            assigned_date: selectedAssignDate ? selectedAssignDate.$d : Assign_date_data ? "" : today,
            due_date: selectedDueDate ? selectedDueDate.$d : Due_date_data ? "" : "",
            match_id: data.id,
            analysis_setup: analysisType?.value,
            reviewer_username: reviewer_data,
          },
          token,
        })
      ));
    const analystsRemoved = await dispatch(
      removeAnalystAssignment({ token, matchId: data.id, usernames: removedAnalysts, role: "analyst" })
    );
    const reviewersRemoved = await dispatch(
      removeAnalystAssignment({ token, matchId: data.id, usernames: removedReviewers, role: "reviewer" })
    );
    const ported =
      addedOrganizers.length === 0 ||
      (await dispatch(
        portMatch({
          data: {
            organizer_list: addedOrganizers,
            port_list: [data.id],
            port_type: "match",
          },
          token,
        })
      ));

    refreshData();

    const failed = [
      !assigned && "assigning analysts/reviewers",
      !analystsRemoved && "removing analysts",
      !reviewersRemoved && "removing reviewers",
      !ported && "updating organizers",
    ].filter(Boolean);
    if (failed.length > 0) {
      // Keep the dialog open so the change can be retried.
      toast.error(`Could not save: ${failed.join(", ")}. Check your connection and try again.`);
      return;
    }

    toast.success("Match assignment updated");
    handleClose();
  };

  if (!data) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "520px",
          maxWidth: "95vw",
          borderRadius: "16px",
          border: "1px solid var(--border-1)",
          backgroundColor: "var(--surface-1)",
        },
      }}
      BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.4)" } }}
    >
      {/* Title bar */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 1.5,
          px: 3,
        }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "rgba(232,108,0,1)", flexShrink: 0 }} />
          <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "var(--text-1)" }}>
            Edit Assignments
          </Typography>
          <Chip
            label={`Match #${data?.id}`}
            size="small"
            sx={{
              fontSize: "11px",
              height: 22,
              fontWeight: 600,
              backgroundColor: "rgba(232,108,0,0.1)",
              color: "rgba(232,108,0,1)",
            }}
          />
        </Stack>
        <IconButton size="small" onClick={handleClose} sx={{ color: "var(--text-2)" }}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: "16px !important", pb: 1, px: 3, display: "flex", flexDirection: "column", gap: 2 }}>

        {/* Teams info line */}
        <Typography sx={{ fontSize: "12px", color: "var(--text-2)", mt: -0.5 }}>
          {data?.team_a_details?.name} vs {data?.team_b_details?.name}
        </Typography>

        {/* Analysts */}
        <LabeledField label="Assigned Analysts">
          <Autocomplete
            limitTags={2}
            multiple
            options={allAnalyst || []}
            value={analysts?.map((i) => allAnalyst?.find((u) => u.id === i)).filter(Boolean)}
            onChange={(_, newValue) => handleAnalystChange(newValue.map((val) => val.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option?.name || ""}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ fontSize: "13px" }}>
                <Checkbox
                  checked={selected}
                  size="small"
                  style={{ marginRight: 6, color: selected ? "rgba(232,108,0,1)" : undefined }}
                />
                {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} placeholder="Search analyst..." size="small" sx={fieldSx} />
            )}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: "var(--surface-2)",
                fontSize: "13px",
                "& fieldset": { borderColor: "var(--border-1)" },
                "&:hover fieldset": { borderColor: "var(--text-2)" },
              },
            }}
          />
        </LabeledField>

        {/* Reviewers */}
        <LabeledField label="Assigned Reviewers">
          <Autocomplete
            limitTags={2}
            multiple
            options={allAnalyst || []}
            value={reviewers?.map((i) => allAnalyst?.find((u) => u.id === i)).filter(Boolean)}
            onChange={(_, newValue) => handleReviewerChange(newValue.map((val) => val.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option?.name || ""}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ fontSize: "13px" }}>
                <Checkbox
                  checked={selected}
                  size="small"
                  style={{ marginRight: 6, color: selected ? "rgba(232,108,0,1)" : undefined }}
                />
                {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} placeholder="Search reviewer..." size="small" sx={fieldSx} />
            )}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: "var(--surface-2)",
                fontSize: "13px",
                "& fieldset": { borderColor: "var(--border-1)" },
                "&:hover fieldset": { borderColor: "var(--text-2)" },
              },
            }}
          />
        </LabeledField>

        {/* Accounts */}
        <LabeledField label="Assigned Accounts">
          <TextField
            select
            SelectProps={{
              multiple: true,
              renderValue: (selected) =>
                selected?.map((i) => allOrganizer?.find((u) => u.id === i)?.name).join(", "),
            }}
            value={organizer}
            onChange={handleOrganizerChange}
            fullWidth
            size="small"
            sx={fieldSx}
          >
            {(allOrganizer || []).map((item) => (
              <MenuItem key={item.id} value={item.id} sx={{ fontSize: "13px" }}>
                <Checkbox
                  checked={!!organizer.find((i) => i === item.id)}
                  size="small"
                  sx={{ mr: 0.5, "&.Mui-checked": { color: "rgba(232,108,0,1)" } }}
                />
                {item.id}: {item.name}
              </MenuItem>
            ))}
          </TextField>
        </LabeledField>

        {/* Dates row */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack direction="row" gap={1.5}>
            <LabeledField label="Assign Date">
              <DesktopDateTimePicker
                onChange={handleAssignDateChange}
                defaultValue={already_assign_date_data ? dayjs(already_assign_date_data) : dayjs(today)}
                slotProps={{
                  textField: { size: "small", fullWidth: true, sx: fieldSx },
                  popper: { placement: "bottom-start" },
                }}
              />
            </LabeledField>
            <LabeledField label="Due Date">
              <DesktopDateTimePicker
                defaultValue={already_due_date_data ? dayjs(already_due_date_data) : null}
                onChange={handleDueDateChange}
                slotProps={{
                  textField: { size: "small", fullWidth: true, sx: fieldSx },
                  popper: { placement: "bottom-start" },
                }}
              />
            </LabeledField>
          </Stack>
        </LocalizationProvider>

        {/* Analysis Type */}
        <LabeledField label="Analysis Type">
          <Select
            value={analysisType}
            onChange={setAnalysisType}
            options={analysisOptions}
            isSearchable={false}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base, { isFocused }) => ({
                ...base,
                borderRadius: "8px",
                fontSize: "13px",
                backgroundColor: isDarkMode ? "var(--surface-2)" : "#f1f2f4",
                borderColor: isFocused ? "rgba(232,108,0,0.6)" : isDarkMode ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.12)",
                boxShadow: isFocused ? "0 0 0 2px rgba(232,108,0,0.15)" : "none",
                color: isDarkMode ? "#f3f4f6" : "#111827",
                minHeight: "38px",
              }),
              menu: (base) => ({
                ...base,
                borderRadius: "8px",
                border: isDarkMode ? "1px solid rgba(255,255,255,0.14)" : "1px solid rgba(0,0,0,0.12)",
                backgroundColor: isDarkMode ? "#1e2230" : "#ffffff",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              }),
              option: (base, { isFocused, isSelected }) => ({
                ...base,
                fontSize: "13px",
                backgroundColor: isSelected ? "rgba(232,108,0,1)" : isFocused ? (isDarkMode ? "rgba(255,255,255,0.06)" : "rgba(232,108,0,0.06)") : "transparent",
                color: isSelected ? "#fff" : isDarkMode ? "#f3f4f6" : "#111827",
              }),
              singleValue: (base) => ({
                ...base,
                color: isDarkMode ? "#f3f4f6" : "#111827",
              }),
              placeholder: (base) => ({
                ...base,
                color: isDarkMode ? "rgba(170,178,190,1)" : "rgba(84,93,105,1)",
                fontSize: "13px",
              }),
            }}
          />
        </LabeledField>

      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1.5, gap: 1 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          size="small"
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            fontSize: "13px",
            borderColor: "var(--border-1)",
            color: "var(--text-2)",
            px: 3,
            "&:hover": { borderColor: "var(--text-1)", backgroundColor: "var(--surface-2)" },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleUpdate}
          disabled={updatingAnalysts || portingAccounts || updatingAllDate}
          variant="contained"
          size="small"
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            fontSize: "13px",
            fontWeight: 600,
            px: 4,
            backgroundColor: "rgba(232,108,0,1)",
            "&:hover": { backgroundColor: "rgba(200,93,0,1)" },
            "&.Mui-disabled": { backgroundColor: "rgba(232,108,0,0.35)", color: "#fff" },
          }}
        >
          {updatingAnalysts || portingAccounts || updatingAllDate ? (
            <CircularProgress size={16} sx={{ color: "#fff" }} />
          ) : (
            "Update"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
